import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import CreateContent from './CreateContent';
import EditContent from './EditContent';
import { Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { SLEditModal, SLCreateModal } from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';

export default function Gmud() {
  const [data, setData] = useState([]);
  const [loadedData, setLoadedData] = useState(true);
  const [analistas, setAnalistas] = useState([]);
  const [clientesSolicitantes, setClientesSolicitantes] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [modulosTotvs, setModulosTotvs] = useState([]);
  const [versoesSistemaTotvs, setVersoesSistemaTotvs] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [templateData, setTemplateData] = useState(null);

  const { perfil } = useSelector(state => state.auth);

  const perfilAtual = analistas?.find(p => p.idPerfil === perfil.idPerfil);

  // useEffect(() => {
  //   async function handleRequests() {
  //     api.get('/signed/geral/acessos/check').then(response => setModulos(response.data));
  //   }

  //   handleRequests();
  // }, []);

  const handleCreateFromTemplate = templateItem => {
    if (!templateItem) {
      console.error('Template item is undefined or null');
      return;
    }
    const newTitle = `${templateItem.titulo} (Cópia)`;
    const newGmudData = {
      // Dados do Solicitante
      idCliente: String(templateItem.idCliente),
      idSolicitante: String(templateItem.idSolicitante),
      solicitanteEmail: templateItem.clienteSolicitanteGmud?.email,
      area: templateItem.area,
      // dataSolicitacao: undefined,
      // Responsáveis pela Mudança
      // idCoordenador: String(templateItem.idCoordenador),
      // idExecutor: String(templateItem.idExecutor),
      idCoordenador: String(perfilAtual?.coordenador?.id || ''),
      idExecutor: String(perfilAtual?.perfil?.usuario?.id || ''),
      // dataHoraInicio: undefined,
      // dataHoraFim: undefined,
      status: 'pendente',
      motivoCancelamento: templateData?.motivoCancelamento ?? undefined,

      // Descrição das Mudanças
      titulo: newTitle,
      descricaoMudanca: templateItem.descricaoMudanca,
      descricaoAtividade: templateItem.descricaoAtividade,

      // Classificações
      atualizacaoDePatch: templateItem.atualizacaoDePatch || false,
      atualizacaoDeLib: templateItem.atualizacaoDeLib || false,
      atualizacaoDeStoredProcedure: templateItem.atualizacaoDeStoredProcedure || false,
      atualizacaoDeSchemasTss: templateItem.atualizacaoDeSchemasTss || false,
      atualizacaoDeMashup: templateItem.atualizacaoDeMashup || false,
      atualizacaoDeTss: templateItem.atualizacaoDeTss || false,
      atualizacaoDeUpddistr: templateItem.atualizacaoDeUpddistr || false,
      compilaFonte: templateItem.compilaFonte || false,
      outros: templateItem.outros || false,
      // githubHashCommit: templateItem.githubHashCommit ?? undefined,
      outrosClassificacao: templateItem.outraClassificacao ?? undefined,

      // InputRadio
      categoria: templateItem.categoria,
      prioridade: templateItem.prioridade,
      origem: templateItem.origem,
      numeroTicket: templateItem?.numeroTicket ?? undefined,
      ambiente: templateItem.ambiente,
      finalidade: templateItem.finalidade,
      janelaAcordada: templateItem.janelaAcordadaComQuem ? 'sim' : 'nao',
      janelaAcordadaComQuem: templateItem.janelaAcordadaComQuem ?? undefined,
      dependeDeOutraMudanca: templateItem.dependeDeOutraMudancaQual ? 'sim' : 'nao',
      dependeDeOutraMudancaQual: templateItem.dependeDeOutraMudancaQual ?? undefined,
      indisponibilidade: templateItem.tempoIndisponibilidadeEmMinutos ? 'sim' : 'nao',
      tempoIndisponibilidade: templateItem.tempoIndisponibilidadeEmMinutos ?? undefined,

      // Plano de execução da mudança
      atividades:
        templateItem.execucao?.length > 0
          ? templateItem.execucao.map(execucao => ({
              descricao: execucao.descricao,
              idResponsavel: String(execucao.idResponsavel),
              // dataHoraInicio: undefined,
              tempoPrevistoEmMinutos: execucao.tempoPrevistoEmMinutos || 0,
            }))
          : [],

      // Plano de validação da mudança
      validacao:
        templateItem.validacao?.length > 0
          ? templateItem.validacao.map(validacao => ({
              descricao: validacao.descricao,
              resultado: validacao.resultado,
              passfail: validacao.passfail === 1 ? 'pass' : validacao.passfail === 0 ? 'fail' : '',
              comentario: validacao.comentario,
            }))
          : [],

      // Plano de Rollback
      rollback:
        templateItem.rollback?.length > 0
          ? templateItem.rollback.map(rollback => ({
              descricao: rollback.descricao,
              idResponsavel: String(perfilAtual?.perfil?.usuario?.id || ''),
              // datahora: undefined,
              comentario: rollback.comentario,
            }))
          : [],

      // Plano de Escalonamento
      escalonamento: [
        {
          idResponsavel: String(perfilAtual?.perfil?.usuario?.id || ''),
          nome: String(perfilAtual?.perfil?.usuario?.nome || ''),
          // telefone: escalonamento.responsavel?.telefone1,
        },
      ],
    };

    setTemplateData(newGmudData);
  };

  useEffect(() => {
    async function fetchClientes() {
      try {
        const response = await api.get('/signed/empresa/gestorprojeto/cliente/clientes', {
          params: { paranoid: false },
        });
        setClientes(response.data || []);
      } catch (error) {
        Sentry.captureException(error);
        console.error('Erro ao buscar clientes:', error);
      }
    }
    fetchClientes();
  }, []);

  async function fetchModulosTotvs() {
    try {
      const response = await api.get('/signed/empresa/modulosTotvs', {
        // params: { paranoid: false },
      });
      setModulosTotvs(response.data || []);
    } catch (error) {
      Sentry.captureException(error);
      console.error('Erro ao buscar módulos TOTVS:', error);
    }
  }
  useEffect(() => {
    fetchModulosTotvs();
  }, []);

  async function fetchVersoesSistemaTotvs() {
    try {
      const response = await api.get('/signed/empresa/versoesSistemaTotvs', {
        // params: { paranoid: false },
      });
      setVersoesSistemaTotvs(response.data || []);
    } catch (error) {
      Sentry.captureException(error);
      console.error('Erro ao buscar versões do sistema TOTVS:', error);
    }
  }
  useEffect(() => {
    fetchVersoesSistemaTotvs();
  }, []);

  useEffect(() => {
    async function fetchClientesScolicitantes() {
      try {
        const response = await api.get(
          '/signed/empresa/gestorprojeto/gerencia/clientesolicitantes',
          {
            params: { ativo: 1 },
          },
        );
        setClientesSolicitantes(response.data || []);
      } catch (error) {
        Sentry.captureException(error);
        console.error('Erro ao buscar clientes:', error);
      }
    }
    fetchClientesScolicitantes();
  }, []);

  useEffect(() => {
    async function fetchCoordenadores() {
      try {
        const response = await api.get('/signed/empresa/gestorprojeto/gerencia/coordenadores', {
          params: { paranoid: false, ativo: 1 },
        });
        setCoordenadores(response.data || []);
      } catch (error) {
        Sentry.captureException(error);
        console.error('Erro ao buscar unidades:', error);
      }
    }
    fetchCoordenadores();
  }, []);

  useEffect(() => {
    async function fetchPerfis() {
      try {
        const response = await api.get('/signed/empresa/gestorprojeto/gerencia/analistas');

        // const perfilAtual = response.data?.find(p => p.idPerfil === perfil.idPerfil);

        setAnalistas(response.data || []);
      } catch (error) {
        Sentry.captureException(error);
        console.error('Erro ao buscar perfis:', error);
      }
    }
    fetchPerfis();
  }, []);

  async function fetchGmuds() {
    if (!perfil?.idEmpresa || !perfil?.idUnidade) return;

    setLoadedData(true);
    try {
      const params = {
        idEmpresa: perfil.idEmpresa,
        idUnidade: perfil.idUnidade,
      };

      const response = await api.get('/signed/empresa/gestorprojeto/gmud', { params });

      setTimeout(() => {
        setLoadedData(false);
        setData(response.data);
      }, 1500);
    } catch (error) {
      Sentry.captureException(error);
      console.error('Erro ao buscar GMUDs:', error);
      setLoadedData(false);
    }
  }

  useEffect(() => {
    if (perfil?.idPerfil && perfil?.idEmpresa && perfil?.idUnidade) {
      fetchGmuds();
    }
  }, [perfil, perfilAtual]);

  return (
    <Main>
      <div className="content">
        <Container
          requests={{
            findAll: async () => {
              const response = await new Promise(resolve =>
                setTimeout(
                  () => resolve({ data: { success: true, message: 'Simulação concluída' } }),
                  3000,
                ),
              );
              console.log('findAll request', response);
            },
            create: async () => {
              console.log('Create request');
            },
            findOne: async thisData => {
              const response = await new Promise(resolve =>
                setTimeout(
                  () => resolve({ data: { success: true, message: 'Simulação concluída' } }),
                  3000,
                ),
              );
              console.log('findOne request', thisData, response);
            },
            deleteOne: async thisData => {
              try {
                // Verificar se o usuário atual é o criador da GMUD
                // if (perfil?.idPerfil !== thisData?.executorGmud?.id) {
                //   throw new Error(
                //     'Você não tem permissão para excluir esta GMUD. Apenas o criador pode excluí-la.',
                //   );
                // }

                const response = await api.delete(
                  `/signed/empresa/gestorprojeto/gmud/${thisData.id}`,
                );

                console.log('Delete request', thisData, response);

                // Recarregar a lista após deletar
                if (response.data.success) {
                  await fetchGmuds();
                }

                return response;
              } catch (error) {
                Sentry.captureException(error);
                console.error('Erro ao deletar GMUD:', error);
                throw error;
              }
            },
          }}
          informationPage={{
            title: 'GMUDs',
            subTitle: 'Gerencie e Crie Suas Solicitações de Mudança',
            icone: 'menu-gemud',
            // menu: true,
            removeBody: true,
          }}
          loaded={loadedData}
        >
          <SLEditModal menu={true} title="Atualizar Gmud" setter={setMountedData}>
            {mountedData && (
              <EditContent
                mountedData={mountedData}
                refetch={fetchGmuds}
                perfilAtual={perfilAtual}
                analistas={analistas}
                clientesSolicitantes={clientesSolicitantes}
                coordenadores={coordenadores}
                clientes={clientes}
                modulosTotvs={modulosTotvs}
                versoesSistemaTotvs={versoesSistemaTotvs}
              />
            )}
          </SLEditModal>

          <SLCreateModal title="Cadastro de GMUD" icone="menu-gemud" menu={true}>
            {data && (
              <CreateContent
                refetch={fetchGmuds}
                perfilAtual={perfilAtual}
                analistas={analistas}
                clientesSolicitantes={clientesSolicitantes}
                clientes={clientes}
                coordenadores={coordenadores}
                templateData={templateData}
                setTemplateData={setTemplateData}
                modulosTotvs={modulosTotvs}
                versoesSistemaTotvs={versoesSistemaTotvs}
              />
            )}
          </SLCreateModal>

          <CustomBodyContent
            {...{ data, loadedData }}
            clientes={clientes}
            perfilAtual={perfilAtual}
            analistas={analistas}
            onCreateFromTemplate={handleCreateFromTemplate}
          />
        </Container>
      </div>
      {/* </LandPage> */}
    </Main>
  );
}
